/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkPortscan } from "../../funcs/networkGetNetworkPortscan.js";
import { GetNetworkPortscanRequest$zodSchema } from "../../models/getnetworkportscanop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkPortscanRequest$zodSchema,
};

export const tool$networkGetNetworkPortscan: ToolDefinition<typeof args> = {
  name: "network-get-network-portscan",
  description: `端口扫描

想检查一下你的服务器上某个端口（比如SSH的22端口或者Web的80端口）是否对外开放？这个工具可以帮你快速确认。

## 功能概述
你可以指定一个主机和端口号，我们的服务器会尝试连接该端口，并告诉你它是开放的（open）、关闭的（closed）还是超时了（timeout）。这对于网络服务配置检查和基本的安全扫描很有用。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkPortscan(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
